<template>
  <div class="box">
    <header-child ref="headerChild" />
    <div class="container">
      <div class="header">
        <div class="left-information">
          <div class="contact-details">
            <img
              class="left"
              src="../../assets/images/img_diaplay_1.png"
              alt=""
            />
            <p>Тел</p>
            <img
              class="right"
              src="../../assets/images/img_diaplay_2.png"
              alt=""
            />
          </div>
          <p class="phone">{{ contact }}</p>
          <div class="contact-details">
            <img
              class="left"
              src="../../assets/images/img_diaplay_1.png"
              alt=""
            />
            <p>Email</p>
            <img
              class="right"
              src="../../assets/images/img_diaplay_2.png"
              alt=""
            />
          </div>
          <p class="mailbox">{{ email }}</p>
          <el-button type="warning" plain @click="doc(1)">О компании</el-button>
          <el-button type="warning" plain @click="doc(4)"
            >Оплата и Доставка</el-button
          >
          <el-button type="warning" plain @click="doc(5)">Контакты</el-button>
        </div>
        <div class="right-information">
          <el-carousel :interval="5000" arrow="always" height="420px">
            <el-carousel-item v-for="(item, index) in imgList" :key="index">
              <img
                class="rim"
                :src="item.image"
                alt=""
                @click="outerChain(item.link)"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 新品上市 -->
      <div class="new-listing">
        <div class="title">
          <img src="../../assets/images/home_img_sort1.png" alt="" />
          <p>новые товары</p>
          <img src="../../assets/images/home_img_sort2.png" alt="" />
        </div>
        <div class="commodity-list">
          <div
            class="commodity"
            v-for="(item, index) in newItem"
            @click="goHref()"
            :key="index"
            :style="
              (index + 1) % 5 == 0 ? 'margin-right:0;' : 'margin-right:30px'
            "
          >
            <img :src="item.thumb" alt="" />
            <span class="name">Новый</span>
            <span class="money">
              {{ calculateThePrice(item.price * 1) }} p
            </span>
          </div>
        </div>
        <!-- 商品分类 -->
        <div class="categories">
          <div class="title">
            <img src="../../assets/images/home_img_sort1.png" alt="" />
            <p>Все категории</p>
            <img src="../../assets/images/home_img_sort2.png" alt="" />
          </div>
          <div class="clothes-classification">
            <div
              class="classification"
              :style="randomColor(index)"
              v-for="(item, index) in categories"
              @click="goHref(item.id, item.name)"
              :key="index"
            >
              <img :src="item.icon" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="aboutUs"
      width="900px"
      :before-close="handleClose"
      class="home"
      :closeOnClickModal="false"
    >
      <p class="title">О нас</p>
      <span class="content" v-html="aboutUsMessage.content"></span>
    </el-dialog>
    <el-dialog
      :visible.sync="paymentAndTransportation"
      width="900px"
      :before-close="handleClose"
      class="home h2"
      :closeOnClickModal="false"
    >
      <p class="title">Оплата и Доставка</p>
      <div
        class="clause"
        v-html="paymentAndTransportationMessage.content"
      ></div>
    </el-dialog>
    <el-dialog
      :visible.sync="contactDetails"
      width="900px"
      :before-close="handleClose"
      class="home h3"
      :closeOnClickModal="false"
    >
      <p class="title">связь</p>
      <div class="contact-details" v-html="contactDetailsMessage.content"></div>
    </el-dialog>
  </div>
</template>

<script>
import headerChild from "../../components/Header";
import { num } from "../../api/method";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { headerChild },
  data() {
    //数据
    return {
      imgList: [],
      newItem: [], //新款商品
      color: ["#e2cdb4", "#b2ced6", "#e9d4aa", "#b9d4c5"], //背景颜色
      aboutUs: false, //关于我们-弹窗
      paymentAndTransportation: false, //付款与运输弹窗
      contactDetails: false, //联系方式
      categories: [], //商品分类
      aboutUsMessage: "", //关于我们
      paymentAndTransportationMessage: "", //付款与运输
      contactDetailsMessage: "", //联系方式
      email: "", //邮箱
      contact: "", //电话
      img: "",
    };
  },
  //计算属性
  computed: {},
  //监控data中的数据变化
  watch: {
    totalNumber(val) {
      // console.log(val);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // console.log(this.totalNumber);
    this.getHomeData();
  },
  mounted() {
    if (!localStorage.getItem("token")) {
      if (this.$store.status == 1) {
        this.$refs.headerChild.dialogTableVisible = true;
        this.$store("setStatus");
      }
    }

    // 打印
  },
  //方法集合
  methods: {
    /**
     * 获取文章
     */
    doc(id) {
      this.api.doc({ id }).then((res) => {
        if (id == 1) {
          this.aboutUs = true;
          this.aboutUsMessage = res.data;
        } else if (id == 4) {
          this.paymentAndTransportation = true;
          this.paymentAndTransportationMessage = res.data;
        } else {
          this.contactDetails = true;
          this.contactDetailsMessage = res.data;
        }
      });
    },
    /**
     * 跳转商品页
     * @param {int} id 传入的分类id
     * @param {String} name 传入的商品分类名称
     */
    goHref(id, name) {
      console.log(6666);
      if (!localStorage.getItem("token")) {
        this.$refs.headerChild.dialogTableVisible = true;
      }
      this.$store.commit("setSearch", "");
      this.$router
        .push({
          name: "CommodityIndex",
          params: {
            id,
            name,
          },
        })
        .catch(() => {}); //把error 抛出来;
    },

    /**
     * 点击轮播图跳转外链
     * @param {String} url 传入的url
     */
    outerChain(url) {
      // location.href = url;
      window.open(url);
    },

    /**
     * 生成颜色随机数
     * @param {String} index 传入的下标
     */
    randomColor(index) {
      return (index + 1) % 3 == 0
        ? "margin-right:0;background:" +
            this.color[Math.round(Math.random() * 3)]
        : "background:" + this.color[Math.round(Math.random() * 3)];
    },

    /**
     * 获取首页数据
     */
    getHomeData() {
      this.api.index({ type: 2 }).then((res) => {
        // console.log(res);
        if (res.status == 1) {
          this.categories = res.data.cate;
          this.imgList =
            res.data.ad.length != 0
              ? res.data.ad
              : [{ image: "https://picsum.photos/360/460?random=1" }];
          this.newItem = res.data.newItem;
          this.email = res.data.email;
          this.contact = res.data.contact;
          // console.log(res.data.ad);
        }
      });
    },

    /**
     * 关闭弹窗
     */
    handleClose(done) {
      done();
    },
    calculateThePrice(str) {
      return num(str);
    },
  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
/deep/ .h3 .el-dialog__body {
  padding: 4px 75px 114px 75px !important;

  .contact-details {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #333333;
    opacity: 1;

    .mailbox {
      display: inline-block;
      width: 50%;
    }
  }
}

/deep/ .h2 .el-dialog__body {
  padding: 4px 50px 78px 78px !important;

  .title::after {
    margin-left: 11px !important;
  }

  .clause {
    padding-left: 11px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #333333;
    opacity: 1;

    .topic {
      font-weight: bold;
    }
  }
}

/deep/ .home .el-dialog__body {
  padding: 4px 50px 48px 78px;

  .title {
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 29px;
    color: #333333;
    opacity: 1;
    // padding-bottom: 15px;
  }

  .title:after {
    display: block;
    margin: 15px 0 38px 0;
    content: "";
    width: 33px;
    height: 4px;
    background: #333333;
  }

  .content {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #333333;
    opacity: 1;
  }
}

.el-button--warning.is-plain {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 21px;
  color: #333333;
  opacity: 1;
}

.el-button {
  width: 100%;
  border: none;
  height: 40px;
  background: #fff8ef;
  opacity: 1;
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-button--warning.is-plain:focus {
  background: #fdf6ec;
  color: #333333;
}

.el-button--warning.is-plain:hover {
  background: #edc18a;
}

.el-button + .el-button {
  margin-left: 0;
}

/deep/ .el-carousel__arrow {
  width: 30px;
  height: 30px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}

/deep/ .el-carousel__container {
  position: relative;
}

/deep/ .el-carousel__arrow--left {
  float: right;
  position: absolute;
  top: 390px;
  left: 748px;
}

/deep/ .el-carousel__arrow--right {
  float: right;
  position: absolute;
  top: 390px;
  left: 790px;
}

/deep/ .el-carousel__arrow i {
  font-size: 16px;
  // background: #edc18a;
  font-weight: bold;
  color: #edc18a;
  opacity: 1;
}

/deep/ .el-carousel__indicators {
  display: none;
}

// /deep/.el-carousel__arrow {
// }
// /deep/.el-carousel__item {
//   // padding: 0 10px;
// }
.box {
  background: #f8f8f8;

  .container {
    margin: 0 auto;
    max-width: 1200px;
    min-width: 1200px;
    padding-top: 20px;
    padding-bottom: 125px;

    .header {
      overflow: hidden;

      .left-information {
        width: 350px;
        height: 420px;
        background: #ffffff;
        opacity: 1;
        float: left;
        margin-right: 10px;
        padding: 30px;
        position: relative;

        .contact-details {
          position: relative;
          height: 19px;

          .left {
            width: 105px;
            height: 6px;
            position: absolute;
            left: 0;
            margin: auto 0;
            top: 0;
            bottom: 0;
          }

          .right {
            width: 105px;
            height: 6px;
            position: absolute;
            right: 0;
            margin: auto 0;
            top: 0;
            bottom: 0;
          }

          p {
            width: 100%;
            position: absolute;
            text-align: center;
            // display: inline-block;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 19px;
            color: #e9ad61;
            opacity: 1;
          }
        }

        .phone,
        .mailbox {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 19px;
          height: 20px;
          color: #333333;
          opacity: 1;
          text-align: center;
          margin: 20px 0 40px 0;
        }

        // .phone {
        // }
      }

      .right-information {
        // display: inline-block;
        float: right;
        width: 840px;
        height: 420px;
        background: rgba(0, 0, 0, 0);
        opacity: 1;

        .rim {
          // padding: 0 5px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .new-listing {
      position: relative;
      margin-top: 60px;

      .title {
        margin-bottom: 30px;
        text-align: center;

        img {
          width: 34px;
          height: 16px;
          opacity: 1;
        }

        p {
          margin: 0 24px;
          display: inline-block;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 31px;
          color: #333333;
          opacity: 1;
        }
      }

      .commodity-list {
        min-height: 456px;

        .commodity {
          display: inline-block;
          width: 216px;
          height: 216px;
          background: rgba(0, 0, 0, 0);
          // border-radius: 5px;
          border: 1px solid #ff3b3b;
          opacity: 1;
          border-radius: 4px;
          margin-bottom: 12px;
          position: relative;

          .name {
            display: block;
            text-align: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 51px;
            height: 22px;
            background: #ff3b3b;
            opacity: 1;
            font-size: 14px;
            border-radius: 4px 0px 4px 0px;
            font-weight: 400;
            line-height: 20px;
            color: #ffffff;
            opacity: 1;
          }

          .money {
            position: absolute;
            padding: 0 4px;
            bottom: 0;
            right: 0;
            display: block;
            text-align: center;
            position: absolute;
            height: 29px;
            background: #ff3b3b;
            opacity: 1;
            font-size: 21px;
            border-radius: 4px 0px 4px 0px;
            font-weight: bold;
            line-height: 29px;
            color: #ffffff;
            opacity: 1;
          }

          img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            object-fit: cover;
          }
        }
      }
    }

    .categories {
      position: relative;
      margin-top: 60px;
      margin-bottom: 30px;

      .title {
        text-align: center;

        img {
          width: 34px;
          height: 16px;
          opacity: 1;
        }

        p {
          margin: 0 24px;
          display: inline-block;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          line-height: 31px;
          color: #333333;
          opacity: 1;
        }
      }

      .clothes-classification {
        width: 100%;
        position: relative;

        .classification {
          margin-right: 67px;
          margin-bottom: 52px;
          display: inline-block;
          width: 355px;
          height: 406px;
          opacity: 1;
          border-radius: 10px;
          padding: 10px 10px 60px 10px;
          text-align: center;

          img {
            width: 335px;
            height: 335px;
            background: #fcfbfb;
            opacity: 1;
            border-radius: 6px;
          }

          span {
            display: block;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 21px;
            color: #ffffff;
            opacity: 1;
            margin-top: 16px;
          }
        }
      }
    }
  }
}
</style>
